export var Domain;
(function (Domain) {
    Domain["LOCALHOST"] = "localhost";
    Domain["PPLUS"] = "paramountplus.com";
    Domain["CBSCOM"] = "cbs.com";
})(Domain || (Domain = {}));
